/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SubjectStatusEnum,
    SubjectStatusEnumFromJSON,
    SubjectStatusEnumFromJSONTyped,
    SubjectStatusEnumToJSON,
} from './SubjectStatusEnum';

/**
 * 
 * @export
 * @interface SubjectStatusHistoryEntryDTO
 */
export interface SubjectStatusHistoryEntryDTO {
    /**
     * 
     * @type {SubjectStatusEnum}
     * @memberof SubjectStatusHistoryEntryDTO
     */
    status?: SubjectStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SubjectStatusHistoryEntryDTO
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectStatusHistoryEntryDTO
     */
    userName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SubjectStatusHistoryEntryDTO
     */
    createdAt?: Date;
}

export function SubjectStatusHistoryEntryDTOFromJSON(json: any): SubjectStatusHistoryEntryDTO {
    return SubjectStatusHistoryEntryDTOFromJSONTyped(json, false);
}

export function SubjectStatusHistoryEntryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectStatusHistoryEntryDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : SubjectStatusEnumFromJSON(json['status']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
    };
}

export function SubjectStatusHistoryEntryDTOToJSON(value?: SubjectStatusHistoryEntryDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': SubjectStatusEnumToJSON(value.status),
        'message': value.message,
        'userName': value.userName,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
    };
}

